import { render, staticRenderFns } from "./nc-overlay.vue?vue&type=template&id=5b203333"
import script from "./nc-overlay.vue?vue&type=script&lang=js"
export * from "./nc-overlay.vue?vue&type=script&lang=js"
import style0 from "./nc-overlay.vue?vue&type=style&index=0&id=5b203333&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports